import { createFileRoute, Outlet, redirect } from "@tanstack/react-router";
import { AppSidebar } from "@/components/app-sidebar";
import { SiteHeader } from "@/components/site-header";
import { SidebarInset, SidebarProvider } from "@/components/ui/sidebar";
import { getCachedSession } from "@/lib/auth-client";
import { hasLoadedZeroSiteClaims } from "@/lib/site-claims";

export const Route = createFileRoute("/dashboard")({
  component: DashboardLayout,
  beforeLoad: async ({ location }) => {
    // Validate session
    const { data: session, error } = await getCachedSession();
    if (error || !session) {
      throw redirect({
        to: "/auth/signin",
        search: {
          redirect: location.href,
        },
      });
    }

    // Send non-admin users with zero site assignments to the
    // "contact your admin" page rather than an empty dashboard.
    // `hasLoadedZeroSiteClaims` returns false when the JWT hasn't
    // loaded yet, so a valid user can't be falsely locked out.
    const role = (session.user as { role?: string | null } | undefined)?.role;
    if (role !== "admin" && hasLoadedZeroSiteClaims()) {
      throw redirect({ to: "/no-access" });
    }

    return { session };
  },
  staticData: {},
});

function DashboardLayout() {
  return (
    <SidebarProvider
      style={
        {
          "--sidebar-width": "248px",
          "--header-height": "calc(var(--spacing) * 12)",
        } as React.CSSProperties
      }
    >
      <AppSidebar />
      <SidebarInset className="min-w-0 overflow-x-auto">
        <SiteHeader />
        <div className="mx-auto flex w-full max-w-7xl flex-1 flex-col">
          <Outlet />
        </div>
      </SidebarInset>
    </SidebarProvider>
  );
}
